<template>
  <div class="w-full flex justify-center items-center bg-gradient-to-b from-woodsmoke-300/10 flex-col">



    <nav class="w-full h-full sm:hidden block px-4 bg-gradient-to-b from-limed-spruce-900 to-transparent pb-8 pt-8">
      <NuxtLink to="/app">
        <button class="bg-turquoise-500/20 border-turquoise-900 text-turquoise-500 shadow-xl rounded-full btn btn-circle btn-sm mb-4">
          <Icon name="mdi:arrow-left"></Icon>
        </button>
      </NuxtLink>

      <div>
        <h1 class="text-3xl font-light text-white">Account</h1>
        <!-- <p>Oxbull Calendar - Information at a glance</p> -->
      </div>
    </nav>

    <article class="w-full max-w-lg lg:pt-20 p-4">
      <p v-if="_isStaking" class="font-light mb-3">
        <span class="text-turquoise-500">{{ _username }}'s</span>
        Oxbull Account
      </p>

      <div v-if="!_isUnstaking" class="p-4 border rounded-xl border-white/30 flex justify-center items-center flex-col relative overflow-hidden">
        <div :class="[loading ? 'opacity-0' : 'z-20 opacity-100', 'duration-300']" class="w-full flex justify-between items-center">
          <div class="">
            <p class="text-woodsmoke-100">Address:</p>
            <p>
              <span class="text-white text-lg">{{ $address?.substring(0, 15) }}</span>
            </p>
          </div>

          <div>
            <div class="text-right">
              <p class="text-woodsmoke-100">OXI Staked</p>
              <p class="text-white text-3xl font-light">{{ _staked }} OXI</p>

              <button @click="refreshData()">Refresh</button>
            </div>
          </div>
        </div>

        <div :class="[loading ? 'opacity-0' : 'z-20 opacity-100', 'duration-300']" class="w-full text-left mt-2">
          <div class="text-sm text-woodsmoke-50">
            <span>{{ stakedDayDuration }}</span>
            <!-- <span>{{ userState?.stake_detail?.staked_duration_of_latest_tier > 0 ? `Day ${userState?.stake_detail?.staked_duration_of_latest_tier}` : "" }}</span> -->
            <span class="mx-1">&middot;</span>
            <span>{{ userState?.stake_detail?.staked_timestamp_of_latest_tier  ? `Since ${format(fromUnixTime(userState?.stake_detail?.staked_timestamp_of_latest_tier), "d MMM yyyy")}` : "" }}</span>
          </div>
          <!-- <div class="text-sm text-woodsmoke-50">Funded: {{ accountData?.projectFunded }} Projects</div> -->
        </div>

        <p :class="[loading ? 'opacity-0' : 'z-20 opacity-100', 'duration-300']" class="mt-4 mb-2 w-full text-left text-woodsmoke-100 px-1">Tiers</p>

        <div :class="[loading ? 'opacity-0' : 'z-20 opacity-100', 'duration-300']" class="w-full flex space-x-2">
          <!-- <div class="flex rounded-full bg-white/10 p-1 justify-center items-center px-3 space-x-2">
          <div class="" >{{ getTiers(_staked).one }} Tier One</div>
          <img class="w-6" :src="`https://oxbull-presale.s3.amazonaws.com/tier1.svg`" />
        </div> -->

          <div :class="[getTiers(_staked).one > 0 ? 'opacity-100' : 'opacity-10']" class="w-1/3 bg-white/5 p-3 rounded-md border border-white/5 flex justify-between items-center shadow">
            <div>
              <div class="text-turquoise-500">{{ getTiers(_staked).one }}</div>
              <p class="uppercase tracking-widest font-light text-white text-sm">Tier One</p>
            </div>
            <img class="w-10" :src="`https://oxbull-presale.s3.amazonaws.com/tier1.svg`" />
          </div>

          <div :class="[getTiers(_staked).two > 0 ? 'opacity-100' : 'opacity-10']" class="w-1/3 bg-white/5 p-3 rounded-md border border-white/5 flex justify-between items-center shadow">
            <div>
              <div class="text-turquoise-500">{{ getTiers(_staked).two }}</div>
              <p class="uppercase tracking-widest font-light text-white text-sm">Tier Two</p>
            </div>
            <img class="w-10" :src="`https://oxbull-presale.s3.amazonaws.com/tier2.svg`" />
          </div>

          <div :class="[getTiers(_staked).three > 0 ? 'opacity-100' : 'opacity-10']" class="w-1/3 bg-white/5 p-3 rounded-md border border-white/5 flex justify-between items-center shadow">
            <div>
              <div class="text-turquoise-500">{{ getTiers(_staked).three }}</div>
              <p class="uppercase tracking-widest font-light text-white text-sm">Tier Three</p>
            </div>
            <img class="w-10" :src="`https://oxbull-presale.s3.amazonaws.com/tier3.svg`" />
          </div>
        </div>

        <!-- <div :class="[loading ? 'opacity-0' : 'z-20 opacity-100', 'duration-300']" v-if="hasPsp" class="w-full mt-2 flex justify-start items-center">
          <div class="-mb-3 sm:mb-0 backdrop-blur-sm bg-white/10 px-2 border border-white/5 text-turquoise-500 skeleton p-1 text-sm rounded-md space-x-1">
            <Icon name="fa-solid:check" class="w-3 h-3" />
            <span>Private Sale Pass Activated</span>
          </div>
        </div> -->

        <div :class="[loading ? 'skeleton' : '']" class="w-full h-full bg-limed-spruce-900 absolute flex justify-center items-center">
          <div class="w-[20rem] h-[20rem] bg-turquoise-500/30 top-[-60%] left-[-20%] rounded-full blur-3xl absolute"></div>
          <div class="w-[16rem] h-[16rem] bg-turquoise-500/20 bottom-[-70%] right-[-20%] rounded-full blur-3xl absolute"></div>
          <div class="w-[12rem] h-[12rem] bg-purple-500/20 top-[-50%] right-[-10%] rounded-full blur-3xl absolute"></div>
          <div class="w-[22rem] h-[22rem] bg-purple-500/10 bottom-[-50%] left-[-10%] rounded-full blur-xl absolute"></div>
        </div>
      </div>

      <div v-if="_isUnstaking" class="p-4 flex flex-col items-center">
        <div class="w-full border rounded-xl border-white/10 flex justify-center items-center flex-col relative bg-white/5 p-4">
          <template v-if="!canWithdraw">
            <div class="text-white text-xl font-light">You've Unstaked</div>
            <p class="text-center w-4/5 mb-4 mt-2">You can only withdraw your OXI tokens after 15 days:</p>

            <div class="w-full grid grid-cols-4 justify-center items-center text-center bg-white/5 p-2 py-4 rounded-xl shadow-xl">
              <div>
                <span class="countdown text-2xl text-white">
                  <span :style="`--value:${unstakedCountdown?.days};`"></span>
                </span>
              </div>
              <div>
                <span class="countdown text-2xl text-white">
                  <span :style="`--value:${unstakedCountdown?.hours};`"></span>
                </span>
              </div>
              <div>
                <span class="countdown text-2xl text-white">
                  <span :style="`--value:${unstakedCountdown?.minutes};`"></span>
                </span>
              </div>
              <div>
                <span class="countdown text-2xl text-white">
                  <span :style="`--value:${unstakedCountdown?.seconds};`"></span>
                </span>
              </div>

              <div>Days</div>
              <div>Hours</div>
              <div>Minutes</div>
              <div>Seconds</div>
            </div>

            <div class="mt-3 text-woodsmoke-50 mb-4">Tokens unstaked: {{ Math.floor( Number(userState?.stakes?.unstakeAmount) * 1000 ) / 1000 }} OXI</div>

          </template>
          <template v-else>
            <div class="text-white text-xl font-light">You've Unstaked</div>
            <p class="text-center w-4/5 mb-4 mt-2">Timelock completed.<br>You may now withdraw without penalty.</p>
            <div class="mt-3 text-woodsmoke-50 mb-4">Tokens unstaked: {{ Math.floor( Number(userState?.stakes?.unstakeAmount) * 1000 ) / 1000 }} OXI</div>
            <!-- Same restake/withdraw buttons as above -->
          </template>

            <div class="w-full grid grid-cols-2 gap-2">
              <div @click="restake()" class="btn h-auto min-h-0 border-none text-left m-0 w-full flex justify-between items-start flex-col bg-white/5 p-3 rounded-xl">
                <Icon class="text-3xl mb-2 text-turquoise-500" name="material-symbols:refresh"></Icon>
                <div>
                  <p class="text-xl text-white font-light">Restake</p>
                  <p class="text-sm text-woodsmoke-50 font-normal">Restake OXI token</p>
                </div>
                <div class="mt-3 font-light text-turquoise-300">click to restake</div>
              </div>

              <div @click="_withdrawButton()" class="btn h-auto min-h-0 border-none text-left m-0 w-full flex justify-between items-start flex-col bg-white/5 p-3 rounded-xl relative">
                <Icon class="text-3xl mb-2 text-woodsmoke-100" name="icon-park-solid:circle-right-up"></Icon>
                <div>
                  <p class="text-lg text-white font-light">Withdraw</p>
                  <p class="text-sm text-woodsmoke-50 font-normal">Withdraw your OXI Tokens</p>
                  <div v-if="!canWithdraw" class="w-full flex justify-end absolute top-0 right-0 p-2">
                    <div class="bg-yellow-400/10 rounded-full p-2 px-3 text-yellow-500">
                      <p>Penalty: 30%</p>
                    </div>
                  </div>
                  <div class="mt-3 font-light text-turquoise-300">click to withdraw</div>
                </div>
              </div>
            </div>
          
        </div>

        <!-- Update the Go Back button styling -->
        <button 
          @click="showUnstakeView = false" 
          class="w-full max-w-lg mt-4 p-4 border rounded-xl border-white/10 bg-white/5 flex items-center justify-center text-white hover:bg-white/10 duration-200"
        >
          Go Back
        </button>
      </div>

        <!-- Update the ongoing unstake card amount -->
        <div v-if="hasOngoingUnstake && _isStaking" class="w-full max-w-lg p-4">
          <div class="p-4 border rounded-xl border-white/10 bg-white/5 flex items-center justify-between">
            <div>
              <p class="text-sm text-woodsmoke-100">Ongoing Unstake</p>
              <div class="flex items-center space-x-2">
                <span class="text-white">{{ Math.floor(Number(userState?.stakes?.unstakeAmount) * 100) / 100 }} OXI</span>
                <span class="text-woodsmoke-100">·</span>
                <span class="text-woodsmoke-100">{{ unstakedCountdown?.days }}d {{ unstakedCountdown?.hours }}h {{ unstakedCountdown?.minutes }}m left</span>
              </div>
            </div>
            <button 
              @click="showUnstakeView = true" 
              class="btn btn-sm bg-white/10 text-turquoise-500 border-none"
            >
              View
            </button>
          </div>
        </div>

        <!-- Modify the bottom navigation bar -->
        <div class="w-full grid grid-cols-4 justify-center items-center mt-12">
          <!-- If we're in unstake view and have staked balance, show back button instead of stake -->
          <div v-if="showUnstakeView && _isStaking" class="w-full flex justify-center items-center flex-col py-2">
            <button 
              @click="showUnstakeView = false" 
              class="btn btn-circle border-none lg:w-16 lg:h-16 w-14 h-14 bg-white/10 mb-2"
            >
              <Icon name="mdi:arrow-left" class="text-white w-6 h-6" />
            </button>
            <p class="text-white font-light text-sm tracking-widest">Back</p>
          </div>
          <!-- Otherwise show normal stake button -->
          <NuxtLink v-else to="/app/stake">
            <div class="w-full flex justify-center items-center flex-col py-2">
              <button class="btn btn-circle border-none lg:w-16 lg:h-16 w-14 h-14 bg-turquoise-500 mb-2">
                <Icon name="material-symbols:add" class="text-turquoise-900 w-6 h-6" />
              </button>
              <p class="text-white font-light text-sm tracking-widest">Stake</p>
            </div>
          </NuxtLink>

          <div class="w-full flex justify-center items-center flex-col py-2">
            <button :disabled="userState?.stakes?.amount == 0 || !userState?.stakes?.enrolled || oxbRewards < 1" @click="harvest()" class="btn btn-circle border-none lg:w-16 lg:h-16 w-14 h-14 bg-white/10 mb-2 disabled:opacity-20">
              <Icon name="ph:plant-fill" class="text-white w-6 h-6" />
            </button>
            <p :class="[userState?.stakes?.amount == 0 || !userState?.stakes?.enrolled ? 'opacity-20' : '']" class="text-white font-light text-sm tracking-widest">Harvest</p>
          </div>

          <div class="w-full flex justify-center items-center flex-col py-2">
            <button :disabled="userState?.stakes?.amount == 0 || !userState?.stakes?.enrolled" @click="showUnstakeWarning = true" class="btn btn-circle border-none lg:w-16 lg:h-16 w-14 h-14 bg-white/10 mb-2 disabled:opacity-20">
              <Icon name="mdi:minus" class="text-white w-6 h-6" />
            </button>
            <p :class="[userState?.stakes?.amount == 0 || !userState?.stakes?.enrolled ? 'opacity-20' : '']" class="text-white font-light text-sm tracking-widest">Unstake</p>
          </div>

          <!-- <div class="w-full flex justify-center items-center flex-col py-2">
            <button class="btn btn-circle border-none lg:w-16 lg:h-16 w-14 h-14 bg-white/10 mb-2">
              <Icon name="fluent:arrow-up-right-16-filled" class="text-white w-6 h-6" />
            </button>
            <p class="text-white font-light text-sm tracking-widest">Withdraw</p>
          </div> -->

          <!-- <ClientOnly>
            <VTooltip>
            <div class="w-full flex justify-center items-center flex-col py-2">
              <button @click="migrate()" class="btn btn-circle border-none lg:w-16 lg:h-16 w-14 h-14 bg-white/10 mb-2">
                <Icon name="lucide:split" class="text-white w-6 h-6" />
              </button>
              <p class="text-white font-light text-sm tracking-widest">Migrate</p>
            </div>

            <template #popper>Coming Soon</template>
          </VTooltip>
          </ClientOnly> -->

          <div class="w-full flex justify-center items-center flex-col py-2">
            <button disabled="true" @click="migrate()" class="btn btn-circle border-none lg:w-16 lg:h-16 w-14 h-14 bg-white/10 mb-2 disabled:opacity-20">
              <Icon name="lucide:split" class="text-white w-6 h-6" />
            </button>
            <p class="text-white font-light text-sm tracking-widest">Migrate</p>
          </div>
        </div>

        <div class="w-full grid grid-cols-4 justify-center items-center text-center text-sm">
          <div></div>
          <div>
            <span v-if="_isStaking && oxbRewards >= 1">{{ Number(oxbRewards).toFixed(2) }} OXI</span>
          </div>
          <div></div>
          <div></div>
        </div>
      </article>

      <div class="w-full border-t border-t-white/5 mt-2"></div>

      <template v-if="$accessToken || userState">
        <article v-if="!needLinkProfile" class="w-full">
          <div class="w-full flex justify-center items-center p-4 border-b border-b-white/5">
            <div class="flex justify-between items-center w-full max-w-md px-2">
              <div>
                <p class="text-sm">Oxbull Username</p>
                <p class="text-white">{{ _username }}</p>
              </div>

              <!-- <button class="btn border border-white/20 h-auto min-h-0 py-2 bg-white/10" >Update</button> -->
            </div>
          </div>

          <div class="w-full flex justify-center items-center p-4 border-b border-b-white/5">
            <div class="flex justify-between items-center w-full max-w-md px-2">
              <div>
                <p class="text-sm">Telegram Handle</p>
                <p class="text-white">@{{ _telegramHandle }}</p>
              </div>

              <!-- <button class="btn border border-white/20 h-auto min-h-0 py-2 bg-white/10" >Update</button> -->
            </div>
          </div>

          <div class="w-full flex justify-center items-center p-4 border-b border-b-white/5">
            <div class="flex justify-between items-center w-full max-w-md px-2">
              <div>
                <p class="text-sm">Email</p>
                <p class="text-white">{{ _email }}</p>
              </div>

              <!-- <button class="btn border border-white/20 h-auto min-h-0 py-2 bg-white/10" >Update</button> -->
            </div>
          </div>

         
          <div class="w-full flex justify-center items-center p-4 border-b border-b-white/5">
            <div class="flex justify-between items-center w-full max-w-md px-2">
              <div>
                <p class="text-sm">Solana Address</p>
                <p class="text-white break-all">{{ solanaAddress }}</p>
              </div>

              <button v-if="!solanaAddress" @click="openLinkSolanaModal()" class="btn border border-white/20 h-auto min-h-0 py-2 bg-white/10" >Update</button>
            </div>
          </div>


        </article>

        <article v-if="needLinkProfile" class="w-full">
          <div class="p-4 border-b border-b-white/5 flex justify-between items-center space-x-4">
            <div>
              <p class="text-turquoise-500">No Telegram Link Found</p>
              <p class="text-woodsmoke-50">Linking your telegram with Oxbull is important to help us safeguard your account's safety. It's also a mandatory step to enable staking.</p>
            </div>
            <button @click="showBotProfile = true" class="btn border border-white/20 h-auto min-h-0 p-3 px-4 bg-white/10">Link Now</button>
          </div>
        </article>
        
        <article v-if="needBridgeV1" class="w-full p-4">
          <div class="p-6 bg-yellow-500/10 rounded-lg">
            <div class="flex items-center gap-2 mb-2">
              <Icon name="mdi:alert-circle" class="text-yellow-500 text-xl" />
              <p class="text-yellow-500 font-semibold">Urgent: Please upgrade your OXB V1</p>
            </div>

            <p class="text-white/80 text-sm mb-4">
                  Since it is deprecated, please upgrade to V3. Upgraded tokens will be automatically staked.
                </p>

            <div class="flex flex-col md:flex-row gap-6 items-start md:items-end">
              <div class="flex-1 space-y-4">
                <div>
                  <label class="text-sm text-white/50 block mb-2">Available V1 to Bridge</label>
                  <div class="inline-block bg-white/10 text-white font-medium py-2 px-4 rounded-lg">
                    {{ bridgeData?.amount || 0 }} OXB V1
                  </div>
                </div>
                
                
              </div>

              <div class="w-full md:w-auto">
                
                <a v-if="bridgedTransaction" :href="`https://basescan.org/tx/${bridgedTransaction}`" target="_blank"  >
                  <button class="w-full md:w-auto disabled:opacity-70 btn bg-yellow-500/10 text-yellow-500 border-yellow-500/20 hover:bg-yellow-500/20">
                    View on Basescan
                  </button>
                </a>

                <button
                  v-else 
                  :disabled="needLinkProfile" 
                  class="w-full md:w-auto disabled:opacity-70 btn bg-yellow-500/10 text-yellow-500 border-yellow-500/20 hover:bg-yellow-500/20"
                  @click="bridgeV1()"
                >
                  Bridge Now
                </button>

              </div>
            </div>

            <div v-if="needLinkProfile" class="mt-4 text-center">
              <p class="text-red-500 text-sm">Bridge disabled: please link your Telegram to proceed.</p>
            </div>
          </div>
        </article>

        <article v-if="needKwaiMigrate" class="w-full p-4">
          <div class="p-6 bg-yellow-500/10 rounded-lg">
            <div class="flex items-center justify-between gap-2 mb-2">
              <div class="flex gap-2 items-center">
                <Icon name="mdi:alert-circle" class="text-yellow-500 text-xl" />
                <p class="text-yellow-500 font-semibold">Partial Migration Available</p>
              </div>
              <div class="w-full md:w-auto">
                <NuxtLink to="/app/kwai-partial-migrate">
                  <button 
                    :disabled="needLinkProfile" 
                    class="w-full md:w-auto disabled:opacity-70 btn bg-yellow-500/10 text-yellow-500 border-yellow-500/20 hover:bg-yellow-500/20"
                  >
                    {{ migrateButtonText }}  
                  </button>
                </NuxtLink>
              </div>
            </div>

            <!-- <div class="flex justify-between items-center">
              <p class="text-white/80">
                Please migrate your KWAI tokens.
              </p>
              <div class="w-full md:w-auto">
                <NuxtLink to="/app/kwai-partial-migrate">
                  <button 
                    :disabled="needLinkProfile" 
                    class="w-full md:w-auto disabled:opacity-70 btn bg-yellow-500/10 text-yellow-500 border-yellow-500/20 hover:bg-yellow-500/20"
                  >
                    Migrate Now
                  </button>
                </NuxtLink>
              </div>
            </div> -->

            <div v-if="needLinkProfile" class="mt-4 text-center">
              <p class="text-red-500 text-sm">Migration disabled: please link your Telegram to proceed.</p>
            </div>
          </div>
        </article>

      </template>
      <!-- <template v-else>
        <div class="w-full pt-20 flex justify-center items-center flex-col pb-20">
          <div class="text-center">
            <p class="text-white text-lg">Incomplete Authentication</p>
            <p>Please Sign to Complete Authentication</p>
          </div>

          <button class="btn border border-white/20 bg-white/10 mt-4 text-white" @click="userStore.switchAuth()">Request Signature</button>
        </div>
      </template> -->

      <div class="modal" role="dialog" :class="showBotProfile ? 'modal-open' : ''">
        <div class="w-full h-full flex justify-center items-center flex-col bg-black/50 backdrop-blur-md p-4">
          <div class="w-full max-w-md border border-white/10 rounded-md bg-woodsmoke-850">
            <div class="w-full flex justify-between p-4 items-center flex-col h-full text-center">
              <p class="text-white pt-4">To link your Telegram, simply use our auth bot:</p>

              <div>
                <div class="w-full flex flex-col justify-center items-center pt-4">
                  <div class="w-full max-w-md p-4 rounded-md border border-white/20 shadow-turquoise-900/50 shadow-2xl bg-woodsmoke-800">
                    <div class="w-full grid grid-cols-[auto_1fr_auto] justify-center items-center gap-x-4">
                      <div class="w-20 h-20 flex-shrink-0 rounded-full p-1 border border-white/20 bg-white/10">
                        <img class="w-full h-full object-cover rounded-full" src="~/assets/auth_botpic.png" alt="" />
                      </div>

                      <div class="w-full">
                        <div class="text-left">
                          <p class="text-xl text-white">Oxbull Auth Bot</p>
                          <p>@oxb_auth_bot</p>
                          <div class="flex justify-start items-center w-full mt-4">
                            <a :href="telegramUrl" target="_blank" class="btn m-0 min-h-0 lowercase h-auto text-sm bg-woodsmoke-700 p-1 px-2 rounded-md text-turquoise-500 flex justify-start items-center space-x-2 border border-white/20">
                              <p>{{ "t.me/oxb_auth_bot" }}</p>
                              <!-- <span class="iconify" data-icon="akar-icons:link"></span> -->
                              <Icon name="akar-icons:link" />
                            </a>

                            <button @click="copyLink()" class="btn btn-circle btn-sm btn-ghost text-turquoise-500 ml-1">
                              <!-- <span class="iconify" data-icon="akar-icons:copy"></span> -->
                              <Icon name="akar-icons:copy" />
                            </button>
                          </div>
                          <p class="text-sm text-woodsmoke-400 capitalize pt-1">↑ launch bot in Telegram</p>
                        </div>
                      </div>

                      <div class="hidden sm:flex justify-center items-center flex-col">
                        <div class="w-[80px] rounded-md overflow-hidden">
                          <ClientOnly>
                            <vue-qrcode :color="{ dark: '#000000ff', light: '#ffffffff' }" type="image/png" :width="80" :value="telegramUrl" />
                          </ClientOnly>
                        </div>

                        <div class="break-words text-sm text-center leading-3 pt-4">
                          <!-- <button class="btn btn-link btn-xs text-turquoise-500 text-xs capitalize">Open Telegram</button> -->
                          Tg On Mobile?
                          <br />
                          Scan to Launch
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-8 text-sm space-y-2 w-full max-w-md text-left mb-4">
                    <p class="text-turquoise-500 text-base">Important:</p>
                    <p>
                      ● Ensure you're interacting with the correct bot by verifying its username:
                      <span class="text-turquoise-200">@oxb_auth_bot</span>
                    </p>
                    <p>● If launching in Telegram fails, close the telegram app and retry.</p>
                    <p>● For Web3 wallets like Metamask and Trust Wallet, which block direct launches from Telegram, copy and paste the link into your browser to access manually.</p>
                  </div>
                </div>
              </div>
              <div class="w-full">
                <button @click="showBotProfile = false" class="btn w-full bg-turquoise-500 text-turquoise-900 hover:text-white">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <HeadlessTransitionRoot as="template" :show="showUnstakeWarning">
        <HeadlessDialog as="div" class="relative z-50" @close="showUnstakeWarning = false">
          <HeadlessTransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </HeadlessTransitionChild>

          <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <HeadlessTransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                <HeadlessDialogPanel class="relative transform overflow-hidden rounded-lg bg-woodsmoke-900 px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                  <div class="text-center">
                    <template v-if="!unstakeModalShowWarning">
                      <h1 class="text-xl font-light text-white mb-4">Unstake Amount</h1>

                      <div class="w-full space-y-4">
                        <div class="w-full flex justify-between items-center text-sm">
                          <span class="text-woodsmoke-100">Available to unstake:</span>
                          <span 
                            @click="unstakeAmount = _staked" 
                            class="text-white cursor-pointer hover:text-turquoise-500 duration-200"
                          >{{ _staked }} OXI</span>
                        </div>

                        <div class="relative">
                          <input 
                            v-model="unstakeAmount" 
                            type="number" 
                            :max="_staked"
                            class="w-full bg-white/5 rounded-lg p-4 text-white text-2xl focus:outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                            placeholder="0.0"
                          />
                          <button 
                            @click="unstakeAmount = _staked" 
                            class="absolute right-2 top-1/2 -translate-y-1/2 btn btn-sm bg-white/10 text-turquoise-500"
                          >
                            MAX
                          </button>
                        </div>

                        <!-- Replace the compact preview section with the grid layout -->
                        <div class="p-3 rounded-md border border-white/10 bg-white/5">
                          <p class="text-center text-sm text-white mb-2">Preview after unstake:</p>
                          
                          <div class="grid grid-cols-2 gap-4">
                            <div>
                              <p class="text-xs text-woodsmoke-100">New Balance</p>
                              <p class="text-sm text-white">{{ isValidUnstakeAmount ? `${(Number(_staked) - Number(unstakeAmount)).toFixed(4)} OXI` : '-' }}</p>
                            </div>
                            
                            <div>
                              <p class="text-xs text-woodsmoke-100">New Tiers</p>
                              <div class="flex items-center justify-center space-x-3">
                                <template v-if="isValidUnstakeAmount">
                                  <div v-if="previewTiers.one > 0" class="flex items-center">
                                    <span class="text-sm text-turquoise-500">{{ previewTiers.one }}x</span>
                                    <img class="w-5 h-5 ml-1" :src="`https://oxbull-presale.s3.amazonaws.com/tier1.svg`" />
                                  </div>
                                  <div v-if="previewTiers.two > 0" class="flex items-center">
                                    <span class="text-sm text-turquoise-500">{{ previewTiers.two }}x</span>
                                    <img class="w-5 h-5 ml-1" :src="`https://oxbull-presale.s3.amazonaws.com/tier2.svg`" />
                                  </div>
                                  <div v-if="previewTiers.three > 0" class="flex items-center">
                                    <span class="text-sm text-turquoise-500">{{ previewTiers.three }}x</span>
                                    <img class="w-5 h-5 ml-1" :src="`https://oxbull-presale.s3.amazonaws.com/tier3.svg`" />
                                  </div>
                                  <div v-if="previewTiers.one === 0 && previewTiers.two === 0 && previewTiers.three === 0" class="text-sm text-woodsmoke-100">
                                    No Tiers
                                  </div>
                                </template>
                                <template v-else>
                                  <span class="text-sm text-woodsmoke-100">-</span>
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="w-full grid grid-cols-2 gap-4">
                          <button 
                            @click="closeUnstakeModal" 
                            class="btn bg-white/5 text-base font-normal text-white"
                          >
                            Cancel
                          </button>
                          <button 
                            @click="unstakeModalShowWarning = true" 
                            :disabled="!isValidUnstakeAmount"
                            class="btn bg-red-500/10 text-red-500 border-red-500/20 text-base font-normal disabled:opacity-50"
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    </template>

                    <!-- Warning Page -->
                    <template v-else>
                      <h1 class="text-xl font-light text-white mb-2">Confirm Unstake</h1>
                      <p class="text-sm text-woodsmoke-100 mb-4">{{ Number(unstakeAmount).toFixed(4) }} OXI</p>

                      <div class="p-4 rounded-md border border-white/10 bg-white/5 mb-4 text-left">
                        <p class="text-base text-white mb-3">Warning:</p>
                        
                        <div class="space-y-3 text-sm text-woodsmoke-50">
                          <p>1. Upon unstake/partial unstake, your tier will be recalculated based on the remaining staked amount.</p>
                          
                          <p>2. If the staked amount falls below the required threshold, you will not be able to claim tokens, even you had contributed, if the unstake/partial unstake is performed before the project's TGE.</p>
                          
                          <p>3. You can only withdraw your OXI tokens after 15 days.</p>
                          
                          <p>4. You can restake the partially unstaked amount back at any time.</p>
                          
                          <p>5. Should you decide to proceed with an emergency withdrawal for the partially unstaked amount (bypassing the time lock), a penalty of 30% of the total partially unstaked amount will apply.</p>
                        </div>

                        <div class="mt-4 pt-4 border-t border-white/10">
                          <div class="flex items-start space-x-2">
                            <Icon name="mdi:alert-circle" class="text-yellow-500 text-xl flex-shrink-0 mt-0.5" />
                            <p class="text-sm text-yellow-500">
                              <span class="font-medium">Previous Kwai Tier Holders:</span> If you are a previous Kwai Tier 1, 2, or 3 holder, please note that once you unstake, your tier status will be lost. To maintain your tier, we highly recommend using the Partial Migration feature we released earlier, which allows you to move your staked OXI to a new wallet address while keeping your tier intact.
                          </p>
                          </div>
                        </div>
                      </div>

                      <div class="w-full grid grid-cols-2 gap-4">
                        <button 
                          @click="unstakeModalShowWarning = false" 
                          class="btn bg-white/5 text-base font-normal text-white"
                        >
                          Back
                        </button>
                        <button 
                          @click="submitConfirmUnstake" 
                          class="btn bg-red-500/10 text-red-500 border-red-500/20 text-base font-normal"
                        >
                          Confirm
                        </button>
                      </div>
                    </template>
                  </div>
                </HeadlessDialogPanel>
              </HeadlessTransitionChild>
            </div>
          </div>
        </HeadlessDialog>
      </HeadlessTransitionRoot>

      <HeadlessTransitionRoot as="template" :show="showWithdrawWarning">
        <HeadlessDialog as="div" class="relative z-50" @close="showWithdrawWarning = false">
          <HeadlessTransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </HeadlessTransitionChild>

          <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <HeadlessTransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                <HeadlessDialogPanel class="relative transform overflow-hidden rounded-lg bg-woodsmoke-900 px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                  <div class="text-center">
                    <p class="text-sm uppercase">warning</p>
                    <h1 class="text-xl font-light text-white">Are you sure to withdraw?</h1>

                    <div class="py-8 text-woodsmoke-50 text-lg font-light">
                      <p>Your countdown is still active. If you withdraw now, you will be subjected to 30% penalty.</p>
                    </div>

                    <div class="w-full grid grid-cols-2 gap-4">
                      <button @click="showWithdrawWarning = false" class="btn bg-white/5 text-base font-normal text-white">Cancel</button>
                      <button @click="withdraw()" class="btn bg-red-500/10 text-red-500 border-red-500/20 text-base font-normal">Proceed</button>
                    </div>
                  </div>
                </HeadlessDialogPanel>
              </HeadlessTransitionChild>
            </div>
          </div>
        </HeadlessDialog>
      </HeadlessTransitionRoot>



      <HeadlessTransitionRoot as="template" :show="showMigrateWarning">
        <HeadlessDialog as="div" class="relative z-50" @close="showMigrateWarning = false">
          <HeadlessTransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </HeadlessTransitionChild>

          <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <HeadlessTransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                <HeadlessDialogPanel class="relative transform overflow-hidden rounded-lg bg-woodsmoke-900 px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                  <div class="text-center">
                    <p class="text-sm uppercase">warning</p>
                    <!-- <h1 class="text-xl font-light text-white">Are you sure to migrate stake?</h1> -->


                    
                    <div class="py-8 text-woodsmoke-50 text-lg font-light">
                      

                      <div v-if="!otpPassed">
                        <p class="flex">OTP :</p>

                        <div class="flex w-full items-center">
                          <input v-model="migrationOtp" placeholder="Insert OTP" class="input bg-transparent w-full focus:outline-none focus:border-none text-lg text-white p-0 placeholder:text-zinc-500" type="text" />
                          <a href="https://t.me/oxb_auth_bot" class="btn bg-turquoise-700/10 btn-md" target="_blank">Generate OTP with /migrate</a>
                        </div>
                      </div>
                      
                      <div v-if="otpPassed">
                        <p>Migrate to :</p>
                        <input v-model="migrationDestination" placeholder="Insert new wallet address" class="input bg-transparent w-full focus:outline-none focus:border-none text-lg text-white p-0 placeholder:text-zinc-500" type="text" />
                      </div>
                      
                      <p class="text-sm flex w-full mt-2 text-zinc-400">Fee : 20 USD worth ETH on Base</p>
                    </div>


                    <div class="w-full grid grid-cols-2 gap-4">
                      <button @click="showMigrateWarning = false" class="btn bg-white/5 text-base font-normal text-white">Cancel</button>
                      <button v-if="!otpPassed" @click="validateOtp()" class="btn bg-turquoise-500/10 text-turquoise-500 border-turquoise-500/20 text-base font-normal">Validate</button>                
                      <button v-if="otpPassed" @click="performMigrate()" class="btn bg-turquoise-500/10 text-turquoise-500 border-turquoise-500/20 text-base font-normal">Confirm</button>
                    </div>

                  </div>
                </HeadlessDialogPanel>
              </HeadlessTransitionChild>
            </div>
          </div>
        </HeadlessDialog>
      </HeadlessTransitionRoot>


      <HeadlessTransitionRoot as="template" :show="showLinkSolana">
        <HeadlessDialog as="div" class="relative z-50" @close="showLinkSolana = false">
          <HeadlessTransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </HeadlessTransitionChild>

          <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <HeadlessTransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                <HeadlessDialogPanel class="relative transform overflow-hidden rounded-lg bg-woodsmoke-900 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm p-4">
                  <div class="text-center">
                    
                    <h1 class="text-xl font-light text-white my-4">Please Enter your Solana Address</h1>
                    <p class="text-turquoise-500 text-center" >You can only configure your address once.<br>make sure it is correct!</p>

                    <div class="mt-8 space-y-4">
                      <input :disabled="solanaLinkBusy" v-model="solanaAddressInput" placeholder="Insert Solana Address" class="input bg-white/5 p-4 w-full focus:outline-none focus:border-none text-lg text-white placeholder:text-zinc-500" type="text" />
                      <button :disabled="solanaLinkBusy" @click="submitSolanaAddress()" class="btn bg-turquoise-500 w-full text-turquoise-1000 hover:text-white hover:bg-white/10" target="_blank">
                        {{ solanaLinkBusy ? 'Proceed in Wallet...' : 'Confirm and Sign' }}
                      </button>
                    </div>
                    
                    <!-- <div class="py-8 text-woodsmoke-50 text-lg font-light">
                      

                      <div v-if="!otpPassed">
                        <p class="flex">OTP :</p>

                        <div class="flex w-full items-center">
                          <input v-model="migrationOtp" placeholder="Insert OTP" class="input bg-transparent w-full focus:outline-none focus:border-none text-lg text-white p-0 placeholder:text-zinc-500" type="text" />
                          <a href="https://t.me/oxb_auth_bot" class="btn bg-turquoise-700/10 btn-md" target="_blank">Generate OTP with /migrate</a>
                        </div>
                      </div>
                      
                      <div v-if="otpPassed">
                        <p>Migrate to :</p>
                        <input v-model="migrationDestination" placeholder="Insert new wallet address" class="input bg-transparent w-full focus:outline-none focus:border-none text-lg text-white p-0 placeholder:text-zinc-500" type="text" />
                      </div>
                      
                      <p class="text-sm flex w-full mt-2 text-zinc-400">Fee : 20 USD worth BNB</p>
                    </div>


                    <div class="w-full grid grid-cols-2 gap-4">
                      <button @click="showMigrateWarning = false" class="btn bg-white/5 text-base font-normal text-white">Cancel</button>
                      <button v-if="!otpPassed" @click="validateOtp()" class="btn bg-turquoise-500/10 text-turquoise-500 border-turquoise-500/20 text-base font-normal">Validate</button>                
                      <button v-if="otpPassed" @click="performMigrate()" class="btn bg-turquoise-500/10 text-turquoise-500 border-turquoise-500/20 text-base font-normal">Confirm</button>
                    </div> -->

                  </div>
                </HeadlessDialogPanel>
              </HeadlessTransitionChild>
            </div>
          </div>
        </HeadlessDialog>
      </HeadlessTransitionRoot>







    </div>

</template>

<script setup>
import { useUserStore } from "~/stores/user.js";
const userStore = useUserStore();

import { STAKE_ADDRESS } from "~/wagmiConfig.js";
import { stakeABI } from "~/components/Stake/stakeConstants.js";
import { getAccount, watchConnections, readContract, writeContract, waitForTransactionReceipt, watchAccount, getBalance, signMessage } from "@wagmi/core";
import { isPast, format, fromUnixTime } from "date-fns";

import VueQrcode from "vue-qrcode";
const telegramUrl = "tg://resolve?domain=oxb_auth_bot&start=auth";
import copy from "copy-to-clipboard";
import { isAddress, parseEther, formatEther } from "viem";

const copyLink = () => {
  copy(telegramUrl);
  alert("Copied to clipboard!");
};

const { $address, $chainId, $accessToken, $wagmiConfig, $userData, $pullUserData, $fetchHome } = useNuxtApp()

let addressWatch, chainIdWatch, accessTokenWatch, userDataWatch;
// const bnb_balance = ref(0);
const base_balance = ref(0);

const getBnBBalance = async () => {
  bnb_balance.value = (await getBalance($wagmiConfig, {
    address: $address.value,
    chainId: 56,
    unit: "ether",
  })).value;
  console.log('bnb_balance', bnb_balance.value)
}

const getBaseBalance = async () => {
  base_balance.value = (await getBalance($wagmiConfig, {
    address: $address.value,
    chainId: 8453,
    unit: "ether",
  })).value;
  console.log('base_balance', base_balance.value)
}

onMounted(() => {
  renderView();

  addressWatch = watch($address, () => {
    renderView();
  });

  chainIdWatch = watch($chainId, () => {
    renderView();
  });

  accessTokenWatch = watch($accessToken, () => {
    renderView();
  });

  userDataWatch = watch($userData, () => {
    renderView();
  });


});

onBeforeRouteLeave( () => {
  addressWatch();
  chainIdWatch();
  accessTokenWatch();
  userDataWatch();
})

const needLinkProfile = ref(false);
const showBotProfile = ref(false);

const fetchingData = ref(false);

const toast = useToast();

const _toast = (param) => {
  toast.add({
    ...param,
    ui: {
      strategy: "override",
      icon: {
        base: "flex-shrink-0 w-5 h-5 mt-0.5",
        color: "text-{color}-500 dark:text-{color}-400",
      },
      background: "bg-woodsmoke-800/50 backdrop-blur-md",
      container: "border border-turquoise-500/20 relative overflow-hidden",
      title: "text-turquoise-500 text-base",
      description: "text-white text-sm",
    },
  });
};

const loading = computed(() => {
  return fetchingData.value || userStore.signing;
});

let unstakedCountdownInterval = false;
const unstakedCountdown = ref(null);
const canWithdraw = ref(false);


const renderCountdown = () => {
  // canWithdraw.value = isPast(fromUnixTime(accountStore.accountData.unlockedTime));
  canWithdraw.value = isPast(fromUnixTime(userState.value?.stakes?.unlockedTime));

  if(canWithdraw.value){
    unstakedCountdown.value = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  }else{
    let seconds = userState.value?.stakes?.unlockedTime - Math.floor(Date.now() / 1000);
    var days = Math.floor(seconds / 24 / 60 / 60);
    var hoursLeft = Math.floor(seconds - days * 86400);
    var hours = Math.floor(hoursLeft / 3600);
    var minutesLeft = Math.floor(hoursLeft - hours * 3600);
    var minutes = Math.floor(minutesLeft / 60);
    var remainingSeconds = seconds % 60;

    unstakedCountdown.value = {
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: remainingSeconds,
    };
  }
};

let throttle = false;

// const accountData = computed( () => {
//   return $userData.value?.mongo;
// })

const qualification_data = computed( () => {
  return $userData.value?.supabase?.user_qualifications;
})

const linked_user_data = computed( () => {
  return $userData.value?.supabase?.linked_users;
})

const userState = useState('user')

const renderView = async () => {
  
  let main = async () => {
   
  needLinkProfile.value = false;

  if ($accessToken.value) {

    fetchSolanaAddress()
    console.log('userState', userState.value);

    hasOngoingUnstake.value = userState.value?.stakes?.unstakeAmount > 0;
    if(hasOngoingUnstake.value && userState.value?.stakes?.amount == 0) showUnstakeView.value = true;

    if(userState.value?.user_telegram){
      needLinkProfile.value = false;
    } else {
      needLinkProfile.value = true;
    }

    // if (!_isStaking.value) {
    //   if (unstakedCountdownInterval) {
    //     clearInterval(unstakedCountdownInterval);
    //   }

    //   unstakedCountdownInterval = setInterval(() => {
    //     renderCountdown();
    //   }, 500);
    // }

    if (hasOngoingUnstake.value) {
      if (unstakedCountdownInterval) {
        clearInterval(unstakedCountdownInterval);
      }

      unstakedCountdownInterval = setInterval(() => {
        renderCountdown();
      }, 500);
    }


  }

  if ($address.value) {
    await fetchOxbReward();
    checkOxbv1Whitelist();
    checkKwaiMigration(); // Add this line
  }

    fetchingData.value = false;
  }

  if(throttle) clearTimeout(throttle);

  throttle = setTimeout(() => {
    main();
  }, 200);

};

/// UI Data Variables

const oxbRewards = ref(0);

const fetchOxbReward = async () => {
  
  const result = await readContract($wagmiConfig, {
    abi: stakeABI,
    address: STAKE_ADDRESS,
    functionName: "getTotalReward",
    args: [$address.value],
    // chainId: 56
    chainId: 8453
  });

  if(result){
    oxbRewards.value = Number(result) / 1e18;
  }

};

/// Computed UI Data

const _username = computed(() => {
  if(userState.value?.user_username){
    return userState.value.user_username
  }
  return "No Username";
});

const _staked = computed(() => {
  if(userState.value?.stakes?.amount){
    return Math.floor(Number(userState.value?.stakes?.amount) * 100 ) / 100
  }
  return 0;
});

const _telegramHandle = computed(() => {
  if(userState.value?.user_telegram){
    if(userState.value?.user_telegram.charAt(0) === "@") return userState.value.user_telegram.substring(1)
    return userState.value.user_telegram
  }
  return "No Telegram Handle";
});

const _email = computed(() => {
  if(userState.value?.user_email){
    return userState.value.user_email
  }
  return "No Email";
});

const getTiers = (amount) => {
  
  let tiers = {
    one: 0,
    two: 0,
    three: 0,
  };

  /// 
  
  tiers.one = userState.value?.uq?.oxb_stake_tier1_count
  tiers.two = userState.value?.uq?.oxb_stake_tier2_count
  tiers.three = userState.value?.uq?.oxb_stake_tier3_count

  return tiers;

  ///


  // Tier Three check at the beginning
  if (amount < 1000) {
    tiers.three = amount >= 50 ? 1 : 0;
    return tiers;
  }

  // Calculate Tier One
  tiers.one = Math.floor(amount / 8000);
  let remainingAmount = amount % 8000;

  // console.log(amount, remainingAmount)

  // Calculate Tier Two
  if (remainingAmount >= 1000) {
    if (remainingAmount >= 4000) {
      // If remainder after dividing by 4000 is more than 1000, add two Tier Twos
      tiers.two = remainingAmount % 4000 >= 1000 ? 2 : 1;
    } else {
      // One Tier Two for amounts between 1000 and 4000
      tiers.two = 1;
    }
  }

  return tiers;
};

const _isStaking = computed(() => {
  if (showUnstakeView.value) return false;
  return userState.value?.stakes?.amount > 0;
  // return userState.value?.stakes?.enrolled && userState.value?.stakes?.amount > 0;
});

const _isUnstaking = computed(() => {
  if (showUnstakeView.value) return true;
  return (hasOngoingUnstake.value && userState.value?.stakes?.amount <= 0);
  // return !userState?.value?.stakes?.enrolled && userState?.value?.stakes?.amount > 0 && userState?.value?.stakes.unlockedTime > 0;
});

const hasPsp = computed(() => {
  let _hasPsp = false;

  // console.log(userState.value)

  if (!userState?.value) {
    _hasPsp = false;
  }

  if (userState.value?.pspInfo?.isOxbTier1 || userState.value?.pspInfo?.isKwaiTier1) {
    _hasPsp = false;
  // } else if (userState.value?.pspInfo?.oxbPsp?.isPsp || (userState.value?.pspInfo?.kwaiPsp?.isPsp && userState.value?.pspInfo?.kwaiPsp?.stakePspExpiry > 0) || (userState.value?.pspInfo?.kwaiPsp?.isPsp && userState.value?.pspInfo?.kwaiPsp?.nftPspExpiry > 0)) {
  } else if (userState.value?.pspInfo?.oxbPsp?.isPsp) {
    _hasPsp = true;
  }

  return _hasPsp;
});

/// Blockchain Calls

const harvest = async () => {
  // Pause the UI, and then call the contract, wait for transaction receipt, and then unpause the UI

  userStore.pauseUI = true;

  try {

    const contract_fee = await estimateETHFee();  
    console.log('contract_fee', contract_fee);

    const result = await writeContract($wagmiConfig, {
      abi: stakeABI,
      address: STAKE_ADDRESS,
      functionName: "harvest",
      args: [],
      value: contract_fee,
      chainId: 8453,
    });

    // console.log(result);

    await waitForTransactionReceipt($wagmiConfig, {
      hash: result,
      confirmations: 4, 
    });

    refreshData();
    await fetchOxbReward();
    _toast({ id: "harvest", title: "Harvested!", description: "Your OXI tokens have been harvested.", timeout: 5000 });

  } catch (e) {
    console.log(e);
    _toast({ id: "harvest", title: "Fail to harvest.", description: e?.shortMessage, timeout: 5000 });
  }

  userStore.pauseUI = false;


};

const showUnstakeWarning = ref(false);

const unstakeAmount = ref("");
const confirmUnstake = ref(false);

const isValidUnstakeAmount = computed(() => {
  const amount = Number(unstakeAmount.value);
  return amount > 0 && amount <= Number(_staked.value);
});

const unstake = async () => {
  if (!isValidUnstakeAmount.value) return;

  userStore.pauseUI = true;

  try {
    const contract_fee = await estimateETHFee();  
    console.log('contract_fee', contract_fee);

    const result = await writeContract($wagmiConfig, {
      abi: stakeABI,
      address: STAKE_ADDRESS,
      functionName: "unstake",
      args: [parseEther(String(unstakeAmount.value))],
      value: contract_fee,
      chainId: 8453,
    });

    await waitForTransactionReceipt($wagmiConfig, {
      hash: result,
      confirmations: 4, 
    });

    window.dataLayer.push({
      event: "unstake",
      page: window.location.pathname,
    });

    refreshData();
    _toast({ id: "unstake", title: "Unstaked Successfully", description: "Your OXI tokens have been unstaked.", timeout: 5000 });

    renderView();
  } catch (e) {
    console.log(e);
    _toast({ id: "unstake", title: "Failed to unstake", description: e?.shortMessage, timeout: 5000 });
  }

  userStore.pauseUI = false;
};

const restake = async () => {
  // Similarly, we freeze the UI, and then call the contract, wait for transaction receipt, and then unfreeze the UI

  userStore.pauseUI = true;

  try {


    const contract_fee = await estimateETHFee();  
    console.log('contract_fee', contract_fee);

    // const result = await writeContract($wagmiConfig, {
    //   abi: stakeABI,
    //   address: STAKE_ADDRESS,
    //   functionName: "stake",
    //   args: [0],
    //   value: contract_fee,
    //   chainId: 8453,
    // });

    const result = await writeContract($wagmiConfig, {
      abi: stakeABI,
      address: STAKE_ADDRESS,
      functionName: "cancelUnstake",
      args: [],
      value: contract_fee,
      chainId: 8453,
    });



    await waitForTransactionReceipt($wagmiConfig, {
      hash: result,
      confirmations: 4, 
    });

    let totalStakes = userState.value?.stakes?.amount > 0 ? userState.value?.stakes?.amount : 0;
    let tierKey = totalStakes >= 8000 ? "tier1" : totalStakes >= 1000 ? "tier2" : totalStakes >= 50 ? "tier3" : "no_tier";

    window.dataLayer.push({
      event: "restake",
      page: window.location.pathname,
      tier_key: tierKey,
    });

    refreshData();
    _toast({ id: "restake", title: "Restaked Successfully", description: "Your OXI tokens have been restaked.", timeout: 5000 });
    showUnstakeView.value = false;

  } catch (e) {
    console.log(e);
  }

  userStore.pauseUI = false;
};

const showWithdrawWarning = ref(false);

const _withdrawButton = () => {
  if (!canWithdraw.value) {
    showWithdrawWarning.value = true;
  } else {
    withdraw();
  }
};

const withdraw = async () => {
  // Similarly, we freeze the UI, and then call the contract, wait for transaction receipt, and then unfreeze the UI

  showWithdrawWarning.value = false;

  userStore.pauseUI = true;

  try {

    const contract_fee = await estimateETHFee();
    console.log('contract_fee', contract_fee);

    const result = await writeContract($wagmiConfig, {
      abi: stakeABI,
      address: STAKE_ADDRESS,
      functionName: "withdraw",
      args: [],
      value: contract_fee,
      chainId: 8453,
    });
    // console.log(result);

    await waitForTransactionReceipt($wagmiConfig, {
      hash: result,
      confirmations: 4, 
    });

    refreshData();
    _toast({ id: "withdraw", title: "Withdrawn Successfully", description: "Your OXI tokens have been withdrawn.", timeout: 5000 });
    showUnstakeView.value = false;

  } catch (e) {
    console.log(e);
  }

  userStore.pauseUI = false;
};


const showMigrateWarning = ref(false);
const migrate = () => {
  showMigrateWarning.value = true;
  otpPassed.value = false;
  migrationOtp.value = null;
  // getBnBBalance();
  getBaseBalance();
};

const migrationDestination = ref("");
const performMigrate = async () => {

  if(!isAddress(migrationDestination.value)) {
    alert("Please insert a valid bsc wallet address.");
    return;
  }

  try {

    const contract_fee = await estimateETHFee();
    console.log('contract_fee', contract_fee);

    if(base_balance.value < contract_fee) {
      _toast({ id: "migrate", title: "Migration Failed", description: "You need at least 20 USD worth of BNB for the migration fee.", timeout: 5000 });
      return;
    }

    showMigrateWarning.value = false;
    userStore.pauseUI = true;

    const result = await writeContract($wagmiConfig, {
      abi: stakeABI,
      address: STAKE_ADDRESS,
      functionName: "transferStakeDataByUser",
      args: [migrationDestination.value],
      value: String(contract_fee),
    });

    // console.log(result);

    await $fetch("/api/migrate/migrate", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${$accessToken.value}`,
      },
      body: JSON.stringify({
        txn: result,
        from: $address.value,
        to: migrationDestination.value,
      }),
    })

    await waitForTransactionReceipt($wagmiConfig, {
      hash: result,
      confirmations: 4, 
    });

    refreshData();
    // renderView();

    _toast({ id: "migrate", title: "Migrate Successfully", description: "Your OXI tokens have been migrated.", timeout: 5000 });

  } catch(error) {
    console.error(error)
    _toast({ id: "migrate", title: "Migration Failed", description: error?.shortMessage, timeout: 5000 });
  }

  userStore.pauseUI = false;
  migrationDestination.value = null;

}


const refreshData = async () => {
  // await $pullUserData();
  await $fetchHome();
  renderView();
  
};


const estimateETHFee = async () => {
  try {
    const _fee = await readContract($wagmiConfig, {
      abi: stakeABI,
      address: STAKE_ADDRESS,
      functionName: "getCurrentFee",
    });

    // const etherFee = Number(_fee);
    // // const scaleFactor = 10000;
    // // const roundedNumber = Math.ceil(etherFee * scaleFactor) / scaleFactor;
    // // return roundedNumber;
    // return etherFee;


    const etherFee = Number(_fee);

    let scaleFactor = 100000;
    const roundedNumber = Math.ceil(etherFee / 1e18 * scaleFactor) / scaleFactor * 1e18;
    console.log("roundedNumber", roundedNumber, etherFee)
    // return etherFee;
    return String(Math.floor(roundedNumber))

  } catch (error) {
    console.log(error);
    return parseEther("0.05");
  }
};


const migrationOtp = ref(null);
const otpPassed = ref(false);

const validateOtp = async () => {

  if(otpPassed.value) return;

  const response = await $fetch("/api/migrate/validateotp", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${$accessToken.value}`,
    },
    body: JSON.stringify({
      wallet_address: $address.value,
      otp: Number(migrationOtp.value) 
    }),
  })

  // console.log('response', response)
  otpPassed.value = response.validated;

  if(!response?.validated) {
    alert("Invalid OTP.");
    showMigrateWarning.value = false;
  }


}


const showLinkSolana = ref(false);

const solanaLinkBusy = ref(false);
const solanaAddressInput = ref("");
const solanaAddress = ref(false)

const openLinkSolanaModal = () => {
  showLinkSolana.value = true;
}

const fetchSolanaAddress = async () => {
  /// Do someting here
  const response = await $fetch(`/api/solanaLink`, {
      headers: {
        Authorization: `Bearer ${$accessToken.value}`
      }
  })

  solanaAddress.value = response?.solana_address;
}

const submitSolanaAddress = async () => {
  solanaLinkBusy.value = true;

  let message = `Please sign this message to link your Solana address to your Oxbull wallet.\n\nEVM Address: ${$address.value}\nSolana Address: ${solanaAddressInput.value}`;

  try {
    let data = await signMessage($wagmiConfig, {
      message: message
    });

    console.log('data', data);

    const response = await $fetch("/api/solanaLink", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${$accessToken.value}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        evm_address: $address.value,
        solana_address: solanaAddressInput.value,
        signature: data,
        message: message,
      }),
    })

    console.log('response', response);

    if(response.success) {

      showLinkSolana.value = false;

      // fetch solana address
      fetchSolanaAddress();

      _toast({ id: "link_solana", title: "Link Succesfully!", description: "Your Solana address has been linked to your Oxbull wallet.", timeout: 5000 });
    } else {
      throw new Error(response.error);
    }

  } catch(err) {
    console.error(err);

    _toast({ id: "link_solana", title: "Failed to Link", description: "Please try again.", timeout: 5000 });

  }

  solanaLinkBusy.value = false;
  showSolanaLink.value = false;
}


const stakedDayDuration = computed(() => {

  if(userState.value?.stake_detail?.staked_timestamp_of_latest_tier) {
    return `Day ${calculateDaysFromTimestamp(userState.value?.stake_detail?.staked_timestamp_of_latest_tier)}`
  }
  return '';
  // staked_timestamp_of_latest_tier

})

function calculateDaysFromTimestamp(unixTimestamp) {
    // Convert UNIX timestamp (in seconds) to milliseconds
    const givenDate = new Date(unixTimestamp * 1000);

    // Get the current date
    const now = new Date();

    // Calculate the difference in time (in milliseconds)
    const timeDifference = now - givenDate;

    // Convert the time difference to days
    const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

    return daysDifference;
}

const bridgeV1 = async () => {

  userStore.pauseUI = true;

  // await new Promise( resolve => setTimeout(resolve, 1000));
  
  try {

    const contract_fee = await estimateETHFee();
    console.log('contract_fee', contract_fee);

    const result = await writeContract($wagmiConfig, {
      abi: stakeABI,
      address: STAKE_ADDRESS,
      functionName: "migrateOxbv1",
      args: [
        parseEther(bridgeData.value.amount),
        bridgeData.value.proof
      ],
      value: contract_fee,
      chainId: 8453,
    });

    // console.log(result);

    await waitForTransactionReceipt($wagmiConfig, {
      hash: result,
      confirmations: 4, 
    });

    await refreshData();
    /// check transaction hash
    bridgedTransaction.value = result;

    _toast({ id: "bridge_v1", title: "Bridge Successfully", description: "Your V1 OXB tokens have been bridged to OXI.", timeout: 5000 }); 
  } catch (e) {
    console.log(e);
    _toast({ id: "bridge_v1", title: "Fail to bridge.", description: e?.shortMessage, timeout: 5000 });
  }

  userStore.pauseUI = false;
  
}



const needBridgeV1 = ref(false);
const bridgeData = ref(null);
const bridgedTransaction = ref(null);

const checkOxbv1Whitelist = async () => {

  bridgeData.value = OXBV1_WHITELIST.find(x => x.address === $address.value)
  await getBridgeTransaction()
  
  if(bridgeData.value) {
    needBridgeV1.value = true
    if(bridgedTransaction.value) {
      needBridgeV1.value = false;
    }
  } else {
    needBridgeV1.value = false
  }

}




import { gql, request } from 'graphql-request'
import OXBV1_WHITELIST from './oxbv1.json'

const getBridgeTransaction = async () => {
  const query = gql`{
    autoStakeds(
      where: {account: "${$address.value}", action: "oxbv1"}
    ) {
      id
      account
      amount
      action
      blockNumber
      blockTimestamp
      stake
      transactionHash
    }
  }
  `
  const url = "https://api.studio.thegraph.com/query/69360/oxbv3stake/version/latest"
  await request(url, query).then((data) => {
    if(data.autoStakeds.length > 0) bridgedTransaction.value = data.autoStakeds[0].transactionHash
  }).catch(console.error)


}



import KWAITIER_MIGRATE_WHITELIST from './kwaitiermigrate.json'

// Add these with the other refs/reactive state
const needKwaiMigrate = ref(false);
const kwaiTierMigrateData = ref([]);

// Add this new function
const checkKwaiMigration = async () => {
  await getMigrateTransaction();
  kwaiTierMigrateData.value = KWAITIER_MIGRATE_WHITELIST.filter(x => x.address === $address.value)
  needKwaiMigrate.value = kwaiTierMigrateData.value?.length > 0 ? true : false;
};


const migrateTransactions = ref([]);
const getMigrateTransaction = async () => {

  const query = gql`{
    migrateTiers(
      where: {from: "${$address.value}"}
    ) {
      amount
      blockNumber
      blockTimestamp
      from
      id
      index
      isnft
      tier
      to
      transactionHash
    }
  }
  `
  const url = "https://api.studio.thegraph.com/query/69360/oxikwaitiermigrate/version/latest"
  await request(url, query).then((data) => {
    if(data?.migrateTiers?.length > 0) {
      migrateTransactions.value = data?.migrateTiers
    } else {
      migrateTransactions.value = []
    }
  }).catch(console.error)

}

const migrateButtonText = computed(() => {
  return (migrateTransactions?.length >= kwaiTierMigrateData?.length) ? 'View Migration' : 'Migrate Now'
})

// Add this computed property
const previewTiers = computed(() => {
  if (!isValidUnstakeAmount.value) return { one: 0, two: 0, three: 0 };
  
  const newBalance = Number(_staked.value) - Number(unstakeAmount.value);
  let tiers = {
    one: 0,    // Tier 1 (highest)
    two: 0,    // Tier 2 (middle)
    three: 0,  // Tier 3 (lowest)
  };

  // Special case: If amount < 1000, only check for Tier 3
  if (newBalance < 1000) {
    tiers.three = newBalance >= 50 ? 1 : 0;
    return tiers;
  }

  // Calculate Tier One (highest tier)
  tiers.one = Math.floor(newBalance / 8000);
  let remainingAmount = newBalance % 8000;

  // Calculate Tier Two
  if (remainingAmount >= 1000) {
    if (remainingAmount >= 4000) {
      // If remainder after dividing by 4000 is more than 1000, add two Tier Twos
      tiers.two = remainingAmount % 4000 >= 1000 ? 2 : 1;
    } else {
      // One Tier Two for amounts between 1000 and 4000
      tiers.two = 1;
    }
  }

  return tiers;
});

// Add this after the main card (where the red box is in the image)
const hasOngoingUnstake = ref(false); // Toggle this to test the ongoing unstake state
const showUnstakeView = ref(false); // Controls whether to show the unstake view

// // Add this to track ongoing unstake amount
// const ongoingUnstakeAmount = computed(() => {
//   return userState?.value?.stakes?.unstakeAmount || 0;
// });

// Add/update these in the script setup
const unstakeModalShowWarning = ref(false);

// Function to close modal and reset state
const closeUnstakeModal = () => {
  showUnstakeWarning.value = false;
  unstakeModalShowWarning.value = false;
  // unstakeAmount.value = "";
};

// Update the unstake function to use the new confirm flow
const submitConfirmUnstake = async () => {
  closeUnstakeModal();
  await unstake();
};

// // Update the existing unstake function to remove the modal state management
// const unstake = async () => {
//   if (!isValidUnstakeAmount.value) return;

//   userStore.pauseUI = true;

//   try {
//     const contract_fee = await estimateETHFee();  
//     console.log('contract_fee', contract_fee);

//     const result = await writeContract($wagmiConfig, {
//       abi: stakeABI,
//       address: STAKE_ADDRESS,
//       functionName: "unstake",
//       args: [parseEther(String(unstakeAmount.value))],
//       value: contract_fee,
//       chainId: 8453,
//     });

//     await waitForTransactionReceipt($wagmiConfig, {
//       hash: result,
//       confirmations: 4, 
//     });

//     window.dataLayer.push({
//       event: "unstake",
//       page: window.location.pathname,
//     });

//     refreshData();
//     _toast({ id: "unstake", title: "Unstaked Successfully", description: "Your OXI tokens have been unstaked.", timeout: 5000 });

//     renderView();
//   } catch (e) {
//     console.log(e);
//     _toast({ id: "unstake", title: "Failed to unstake", description: e?.shortMessage, timeout: 5000 });
//   }

//   userStore.pauseUI = false;
// };

</script>

<style></style>
